// packages
import * as yup from 'yup';
import recurrencePatternSchema from './components/RecurrencePatternBuilder/RecurrencePatternBuilder.schema';
import i18n from 'config/i18n';
// types
import { ActivityResponse, SchedulingLabel } from 'generated/index';

// utils
import { getLocale } from 'utils/date';
import { ISO_DATE_REGEX } from 'constants/misc';
import dayjs from 'dayjs';

const t = i18n.getFixedT(getLocale());

const planningEntityIdentifierProp = yup
  .mixed<string | number>()
  .notRequired()
  .nullable(true);
const planningEntityIdentifierProps = [
  'id',
  'entityId',
  'externalEntityId',
  'number'
];

const entitySchema = yup.object({
  label: yup.string().nullable(true).notRequired(),
  planningEntityType: yup
    .string()
    .oneOf(['EMPLOYEE', 'CLIENT', 'RESOURCE', 'WORKPLACE'])
    .notRequired(),
  ...planningEntityIdentifierProps.reduce((acc, prop) => {
    acc[prop] = planningEntityIdentifierProp;
    return acc;
  }, {})
});

const optionalEntitySchema = yup.object({
  id: yup.string().optional(),
  label: yup.string().optional()
});

const schema = yup.object({
  start: yup.string().matches(ISO_DATE_REGEX),
  end: yup
    .string()
    .optional()
    .matches(ISO_DATE_REGEX)
    .test(
      'is-after-start',
      t('mrp.appointmentForm.validation.invalid_end'),
      (value, ctx) => dayjs(value).isAfter(ctx.parent.start)
    ),
  activity: yup
    .mixed<ActivityResponse>()
    .nullable(true)
    .required(t('validationFieldRequired', { name: t('activity') })),
  comment: yup.string().optional(),
  recurrencePattern: recurrencePatternSchema,
  planEntities: yup
    .object({
      EMPLOYEE: yup.array().of(entitySchema).default([]),
      CLIENT: yup.array().of(entitySchema).default([]),
      WORKPLACE: yup.array().of(entitySchema).default([]),
      RESOURCE: yup.array().of(entitySchema).default([])
    })
    .default({
      EMPLOYEE: [],
      CLIENT: [],
      WORKPLACE: [],
      RESOURCE: []
    }),
  location: optionalEntitySchema.optional(),
  room: optionalEntitySchema.optional(),
  schedulingLabel: yup
    .mixed<SchedulingLabel>()
    .oneOf(['DEFAULT', 'VV', 'HH', 'BB', 'WORKPLACE', 'PROJECT', 'MRP'])
    .default('MRP')
});

export default schema;
